import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['minInput', 'maxInput', 'minThumb', 'maxThumb', 'range', 'minValue', 'maxValue']
  static values = {
    min: { type: Number, default: 0 },
    max: { type: Number, default: 100 },
    step: { type: Number, default: 1 }
  }

  connect() {
    this.updateSlider()
  }

  minInputChanged() {
    const minVal = parseInt(this.minInputTarget.value) || this.minValue
    const maxVal = parseInt(this.maxInputTarget.value) || this.maxValue

    if (minVal > maxVal) {
      this.minInputTarget.value = maxVal
    }

    this.updateSlider()
  }

  maxInputChanged() {
    const minVal = parseInt(this.minInputTarget.value) || this.minValue
    const maxVal = parseInt(this.maxInputTarget.value) || this.maxValue

    if (maxVal < minVal) {
      this.maxInputTarget.value = minVal
    }

    this.updateSlider()
  }

  updateSlider() {
    const minVal = parseInt(this.minInputTarget.value) || this.minValue
    const maxVal = parseInt(this.maxInputTarget.value) || this.maxValue
    const range = this.maxValue - this.minValue

    const minPercent = ((minVal - this.minValue) / range) * 100
    const maxPercent = ((maxVal - this.minValue) / range) * 100

    this.minThumbTarget.style.left = `${minPercent}%`
    this.maxThumbTarget.style.left = `${maxPercent}%`
    this.rangeTarget.style.left = `${minPercent}%`
    this.rangeTarget.style.width = `${maxPercent - minPercent}%`

    if (this.hasMinValueTarget) {
      this.minValueTarget.textContent = minVal
    }
    if (this.hasMaxValueTarget) {
      this.maxValueTarget.textContent = maxVal
    }
  }

  startDragMin(event) {
    event.preventDefault()
    this.dragging = 'min'
    this.addDragListeners()
  }

  startDragMax(event) {
    event.preventDefault()
    this.dragging = 'max'
    this.addDragListeners()
  }

  addDragListeners() {
    this.boundDrag = this.drag.bind(this)
    this.boundStopDrag = this.stopDrag.bind(this)
    document.addEventListener('mousemove', this.boundDrag)
    document.addEventListener('mouseup', this.boundStopDrag)
    document.addEventListener('touchmove', this.boundDrag)
    document.addEventListener('touchend', this.boundStopDrag)
  }

  drag(event) {
    const slider = this.element.querySelector('[data-range-slider-target="track"]')
    const rect = slider.getBoundingClientRect()
    const clientX = event.type.includes('touch') ? event.touches[0].clientX : event.clientX
    let percent = ((clientX - rect.left) / rect.width) * 100
    percent = Math.max(0, Math.min(100, percent))

    const range = this.maxValue - this.minValue
    let value = Math.round((percent / 100) * range + this.minValue)
    value = Math.round(value / this.stepValue) * this.stepValue

    const minVal = parseInt(this.minInputTarget.value) || this.minValue
    const maxVal = parseInt(this.maxInputTarget.value) || this.maxValue

    if (this.dragging === 'min') {
      value = Math.min(value, maxVal)
      this.minInputTarget.value = value
    } else {
      value = Math.max(value, minVal)
      this.maxInputTarget.value = value
    }

    this.updateSlider()
  }

  stopDrag() {
    this.dragging = null
    document.removeEventListener('mousemove', this.boundDrag)
    document.removeEventListener('mouseup', this.boundStopDrag)
    document.removeEventListener('touchmove', this.boundDrag)
    document.removeEventListener('touchend', this.boundStopDrag)
  }
}
